import Vue from 'vue'
import App from './App.vue'
import VueRouter from './router'
import vuetify from './plugins/vuetify'
import VueLoading from 'vuejs-loading-plugin'
import VueCookies from 'vue-cookies'
import store from './plugins/store.js'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueSweetalert2 from 'vue-sweetalert2';

import VueMask from 'v-mask'
import money from 'v-money'
Vue.use(VueMask);
Vue.use(money, {precision: 2});

Vue.config.productionTip = false

Vue.use(VueLoading)
Vue.use(VueCookies)
Vue.use(VueSweetalert2);

// global variable
Vue.mixin({
  data: function() {
    return {
      isAutherize: false,
      currUser: ''
    }
  }
})

new Vue({
  vuetify,
  router: VueRouter,
  store,
  render: h => h(App)
}).$mount('#app')
